import { styled, css, createGlobalStyle } from 'styled-components';
import { theme } from '../../../../constants/theme.mjs';
import '../../../StyleableSvgImage/index.mjs';
import { withCssTransition } from '../DropdownMenu/DropdownMenu.styles.mjs';
import { StyleableSvgImage } from '../../../StyleableSvgImage/StyleableSvgImage.mjs';
"use strict";
const MAIN_ICON_WIDTH = 78;
const MAIN_GAP_WIDTH = 16;
const TOOLTIP_CLASS_NAME = "product-tooltip";
const RootTopologyContainer = styled.div`
  border-radius: 6px;
  margin-top: 16px;
  position: relative;
`;
const TopologyHeader = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  font-family: ${theme.fontFamily.default};
  gap: 8px;
  line-height: 20px;
  outline: none;
  padding: 0;
  width: fit-content;
`;
const SectionTitle = styled.h5`
  color: #212327;
  display: block;
  font-size: 16px;
  font-weight: 700;
  line-height: normal;
  margin: 0;
`;
const ButtonLabel = styled.span`
  font-size: 12px;
  line-height: 16px;
`;
const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.6, 1);

  ${({
  $isVisible
}) => $isVisible && css`
      overflow: unset;
      opacity: 1;
      max-height: 100vh;
    `}
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: fit-content;
  gap: 20px;
  position: relative;
  transform: translateX(${MAIN_ICON_WIDTH / 2 + MAIN_GAP_WIDTH - 2}px);
`;
const Item = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;
const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 78px;
  position: relative;
  height: 28px;
  background: ${theme.colors.white};
`;
const ItemIcon = styled.img`
  flex-shrink: 0;
  width: ${({
  $width
}) => $width}px;
  height: ${({
  $height
}) => $height}px;
  z-index: 12;
`;
const ItemLabel = styled.span`
  color: #212327;
  font-size: 13px;
  font-weight: 400;
  line-height: normal;
`;
const StyledArrowIcon = styled(StyleableSvgImage)`
  color: #212427;
  transition: transform 0.35s linear;

  ${({
  $isOpen
}) => $isOpen && css`
      transform: rotate(180deg);
    `}
`;
const StyledIcon = styled(StyleableSvgImage)`
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  position: absolute;
  left: -9999px;
  width: 12px;

  ${({
  $isVisible
}) => $isVisible && `
    position: static;
    opacity: 1;
  `}
`;
const ExpandButton = styled.button`
  background: ${theme.colors.primaryBlue};
  color: ${theme.colors.white};
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  cursor: inherit;
`;
const RootSvgContainer = styled.div`
  top: 24px;
  left: 36px;
  height: 100%;
  width: 6px;
  display: flex;
  justify-content: center;
  position: absolute;

  path {
    stroke-dasharray: 0 8;
    stroke-width: 1.7;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    stroke-linejoin: round;
    animation: flow-root 4.3s linear infinite !important;
  }

  #purpleParticlesRoot path {
    stroke-width: 1.5;
    stroke-dasharray: 0 14;
    stroke-dashoffset: 0;
  }

  #blurContainerRoot path {
    filter: blur(10px);
    stroke: rgb(229 241 255);
    stroke-width: 6px;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 0;
    animation: none;
  }

  @keyframes flow-root {
    100% {
      stroke-dashoffset: 150;

      #purpleParticlesRoot path {
        stroke-dashoffset: 220;
      }
    }
  }
`;
const RelativeContentContainer = styled.div`
  height: 100%;
  position: relative;
  width: 100%;
`;
const TopologyMainContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
  position: relative;
  justify-content: center;

  path {
    stroke-dasharray: 0 8;
    stroke-width: 1.7;
    stroke-dashoffset: 135;
    stroke-linecap: round;
    stroke-linejoin: round;
    animation: flow-opposite 4.3s linear infinite !important;
  }

  #purpleParticlesParent path {
    stroke-width: 1.5;
    stroke-dasharray: 0 14;
    stroke-dashoffset: 200;
  }

  #blurContainerParent path {
    filter: blur(2px);
    stroke: rgb(229 241 255);
    stroke-width: 1.5;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 0;
    animation: none;
  }

  @keyframes flow-opposite {
    100% {
      stroke-dashoffset: 0;
    }
  }
`;
const SubNavigationTopologyContainer = styled(TopologyMainContainer)`
  position: absolute;
  left: -9999px;
  padding-top: 64px;
  opacity: 0;
  ${withCssTransition(["opacity"])};
  transition-duration: 0.5s !important;
  width: 100%;

  path {
    stroke-dasharray: 0 8;
    stroke-width: 1.7;
    stroke-dashoffset: 165;
    stroke-linecap: round;
    stroke-linejoin: round;
    animation: flow 4.3s linear infinite !important;
  }

  #purpleParticles path {
    stroke-width: 1.5;
    stroke-dasharray: 0 14;
    stroke-dashoffset: 200;
  }

  #blurContainer path {
    filter: blur(2px);
    stroke: rgb(229 241 255);
    stroke-width: 1.5;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 0;
    animation: none;
  }

  @keyframes flow {
    100% {
      stroke-dashoffset: 0;
    }
  }

  ${({
  $isVisible
}) => $isVisible && css`
      position: relative;
      left: 0;
      opacity: 1;
    `}
`;
const TopologyNavItem = styled.button`
  display: flex;
  background: transparent;
  cursor: ${({
  $isActive
}) => $isActive ? "default" : "pointer"};
  outline: none;
  align-items: center;
  position: relative;
  border-radius: 6px;
  flex-direction: column;
  gap: 4px;
  min-width: 140px;
  border: 2px solid transparent;
  transition: all 0.15s ease-in-out;
  z-index: 50;

  ${({
  $withHover
}) => $withHover && `
    padding: 12px 20px;

    &:hover {
      border: 2px solid #338CFF;
      background: linear-gradient(95deg, rgba(51, 140, 255, 0.20) 1.72%, rgba(107, 210, 253, 0.20) 100%), ${theme.colors.white};

      ${NavIcon}, ${ItemLabel} {
      color: ${theme.colors.primaryBlue};
    }
  `}
`;
const NavIcon = styled.img`
  color: #50565e;
  height: 38px;
  object-fit: contain;
  shape-rendering: crispedges;
`;
const SvgWrapper = styled(StyleableSvgImage)`
  position: absolute;
  top: 0;
  left: 50%;
  width: 100%;
  transform: translateX(-100%);
  shape-rendering: crispedges;
`;
const TooltipLabel = styled.span`
  color: #676f79;
  font-size: 12px !important;
  line-height: 16px !important;
  background: transparent;
  display: inline !important;
`;
const TooltipStyles = createGlobalStyle`
  .${TOOLTIP_CLASS_NAME} {  
    border-radius: 6px;
    box-shadow: 0 0 16px 0 rgb(0 0 0 / 0.16);
    padding: 8px 12px !important;
    font-family: ${theme.fontFamily.default};

      br {
        display: none;
      }
  }
`;
export { ButtonLabel, ContentWrapper, ExpandButton, IconWrapper, Item, ItemIcon, ItemLabel, ItemsContainer, NavIcon, RelativeContentContainer, RootSvgContainer, RootTopologyContainer, SectionTitle, StyledArrowIcon, StyledIcon, SubNavigationTopologyContainer, SvgWrapper, TooltipLabel, TooltipStyles, TopologyHeader, TopologyMainContainer, TopologyNavItem };
//# sourceMappingURL=VisualTopology.styles.mjs.map
